<template>
	<!-- 技能操作列表 -->
	<div class="sj_main" v-if="pageShow">
		<div class="detail_top">
			<div class="sj_breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/home/homepage' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>{{name}}</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="sj_card">
					<div class="card_header">
						<div class="title">{{ name }}</div>
					</div>
					<div class="card_body">
						<div class="sj_flex_list">
							<div class="list_item" v-for="item in list" :key="item.id" @click="handleJump(item)">
								<el-image class="item_img" fit="cover" :src="item.cover">
									<div slot="placeholder" class="image-slot">
										图片加载中
										<span class="dot">...</span>
									</div>
									<div slot="error" class="image_error">图片加载失败</div>
								</el-image>
								<div class="item_title">{{ item.name }}</div>
								<div class="item_text">
									<span>{{ item.description }}</span>
<!--									<span class="tag">{{ item.contentName }}</span>-->
								</div>
							</div>
						</div>
						<div class="sj_page">
							<el-pagination v-if="pageShow"
										   @current-change="handleCurrentChange"
										   background
										   layout="prev, pager, next"
										   :current-page ="currentPage"
										   :hide-on-single-page="true"
										   :total="total">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				pageShow: false,//分页显示与否
				currentPage:1,//默认第一页
				limit: 10,
				total: 1,
				name:'',
				columnId: null,
				list: []
			};
		},
		computed: {
			...mapState(['bindInfo','info'])
		},
		created() {
			this.name=this.$route.query.name
		},
		mounted() {
			this.getData()
		},
		methods: {
			//跳转页面
			handleJump(item) {
				//资源类型，0虚拟仿真1系列课2电子书4技能操作
				if (item.type === 0|| item.type === 5) {
					// this.$router.push({ path: 'detailVirtual', query: { id: item.source,type:item.type } });
					this.$router.push({ path: 'detail', query: { id: item.source, type: item.type } });
				} else if (item.type === 1) {
					this.$router.push({ path: 'detailSeries', query: { id: item.source } });
				} else if (item.type === 4) {
					this.$router.push({ path: 'detailSkill', query: { id: item.source,name:item.name } });
				} else if (item.type === 2) {
					this.$ajax
							.post(this.$api.ebookDetailAndRecord, {
								userId: this.info.id,
								ebookId: item.source
							})
							.then(res => {
								let data = res.data;
								if (data.type === 1) {
									//课件
									this.$ajax
											.post(this.$api.ebookStudyStart, {
												ebookId: item.source,
												userId: this.info.id,
												progress: data.progress
											})
											.then(() => {
												window.open(data.realUrl, '_blank');
											});
								} else if (data.type === 2) {
									//视频
									const { href } = this.$router.resolve({
										name: 'video',
										query: { info: JSON.stringify(data) }
									});
									window.open(href, '_blank');
								} else if (data.type === 3) {
									//音频
									const { href } = this.$router.resolve({
										name: 'audio',
										query: { info: JSON.stringify(data) }
									});
									window.open(href, '_blank');
								}
							});
				}
			},
			getData() {
				this.$ajax.get(this.$api.homePageMore+'?columnId='+this.$route.query.id+'&siteId=&page='+this.currentPage+'&limit=10').then(res => {
					if(res&&res.code===0){
						this.list=res.data
						this.total=res.count
						this.pageShow = true
					}
				})
			},
			/**
			 * 分页
			 */
			handleCurrentChange(val){
				this.currentPage=val;
				this.$nextTick(function () {
					this.getData()
				})
			}
		}
	};
</script>

<style scoped lang="scss">
	.detail_top {
		padding: 0 30px 30px;
		background: #ffffff;
		position: relative;

		.sj_breadcrumb {
			padding: 20px 0;
		}
	}
	.sj_flex_list {
		display: flex;
		flex-wrap: wrap;
		.list_item {
			width: 19%;
			min-height: 220px;
			margin-bottom: 20px;
			overflow: hidden;
			cursor: pointer;
			box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
			-webkit-transition: all 0.3s ease 0s;
			transition: all 0.3s ease 0s;
			@include borderRadius(4px);
			&:hover {
				box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.35);
			}
			&:not(:nth-child(5n)) {
				margin-right: calc(5% / 4);
			}
			.item_img {
				display: block;
				width: 100%;
				height: 140px;
			}
			.item_title {
				font-size: 16px;
				line-height: 20px;
				padding: 16px 20px;
			}
			.item_text {
				@extend .flex;
				justify-content: space-between;
				font-size: 12px;
				line-height: 20px;
				color: #8f9195;
				padding: 0 20px 16px;
				margin-top: -8px;
				.tag {
					@extend .flex;
					align-items: center;
					justify-content: center;
					width: 48px;
					height: 24px;
					font-size: 12px;
					font-weight: bold;
					color: #1d8ae8;
					background-color: rgba(29, 138, 232, 0.1);
					@include borderRadius(4px);
					&.purple {
						color: #af52de;
						background-color: rgba(175, 82, 222, 0.1);
					}
					&.green {
						color: #4ed5c7;
						background-color: rgba(78, 213, 199, 0.1);
					}
				}
			}
		}
	}
	.sj_card {
		padding-bottom: 40px;
		&:last-child {
			padding-bottom: 60px;
		}
		.card_header {
			padding: 25px 0 25px;
			.title {
				font-size: 18px;
				position: relative;
				text-indent: 16px;
				&:before {
					content: '';
					width: 4px;
					background: rgba(20, 119, 237, 1);
					position: absolute;
					top: 0;
					bottom: 0;
					left: 0;
				}
			}
		}
		.card_body {
		}
	}
</style>
